import React, { PureComponent } from 'react';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';

import { CardList, CardSlider } from '../widgets/DataRenderer';
import LinkBack from '../widgets/LinkBack';
import CareerCard from './CareerCard';
import Spinner from '../widgets/Spinner';

import './career.scss';

class CareerTemplate extends PureComponent {
  render() {
    const { vacancies } = this.props;

    const items = (vacancies.results || []).map(item => (
      <CareerCard
        {...item}
        onClick={() => this.props.onCardClick(item.id)}
      />
    ));

    const ListComponent = this.props.isMobile ? CardList : CardSlider;

    return (
      <div className="career">
        <Helmet>
          <title>Вакансии</title>
        </Helmet>

        <div className="career-content">
          <div className="container">
            <LinkBack link="/we/subnavigation/">
              мы <i>вернуться</i>
            </LinkBack>

            <h1 className="career-title">
              Вакансии
            </h1>

            {(!vacancies.isFetching && !!vacancies.results && !!vacancies.results.length) &&
              <p className="career-description">
                Наша компания постоянно развивается, и&nbsp;поэтому нам всегда {' '}
                нужны хорошие специалисты. Если вам есть в&nbsp;чем себя показать, {' '}
                и&nbsp;вы&nbsp;хотите работать в&nbsp;сплоченном коллективе&nbsp;&mdash; {' '}
                приходите, нам есть о&nbsp;чем поговорить!
              </p>
            }

            {(!vacancies.isFetching && !!vacancies.results && !vacancies.results.length) &&
              <div className="vacancies-empty">
                <p className="career-description">
                  К сожалению, вакансий в нашей компании на данный момент нет. <br/>
                  Но если вы талантливый финансовый аналитик, который ищет площадку <br/>
                  для реализаций своих идей и способностей, отправляй свое резюме <br/>
                  на электронную почту:
                </p>

                <a
                  className="career-email"
                  href="mailto:info@uscapital.ru"
                >
                  info@uscapital.ru
                </a>

                <p className="career-description">
                  Мы понимаем ваше желание присоединиться <br/>
                  к команде «Юнисервис Капитал» и готовы к диалогу.
                </p>
              </div>
            }
          </div>

          <div className="data-renderer-container">
            <div className="container">
              {(vacancies.isFetching && !vacancies.results) &&
                <div className="career-spinner">
                  <Spinner />
                </div>
              }

              <ListComponent items={items} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

CareerTemplate.propTypes = {
  vacancies: PropTypes.shape({
    results: PropTypes.arrayOf(PropTypes.object),
    isFetching: PropTypes.bool,
    fetchingErrors: PropTypes.object
  }),
  isMobile: PropTypes.bool,
  onCardClick: PropTypes.func
};

export default CareerTemplate;



// WEBPACK FOOTER //
// ./src/components/Career/CareerTemplate.js